import React, { useState } from "react";
import styled from "styled-components";
import * as u from "@/utils";
import RxTriangle from "@/components/ui/display/RxTriangle";

type RxAccordionType = React.FC<RxAccordionProps> & {
  Item: React.FC<AccordionItemProps>;
};

type AccordionItem = {
  title: string;
  content: string | React.ReactNode | AccordionItem[];
};

type RxAccordionProps = {
  items: AccordionItem[];
};

const RxAccordion: RxAccordionType = ({ items }) => {
  return (
    <S.AccordionWrapper className="accordion">
      {items.map((item) => (
        <RxAccordion.Item
          key={item.title}
          title={item.title}
          className={Array.isArray(item.content) ? "has-accordion-child" : ""}
        >
          {Array.isArray(item.content) ? (
            <RxAccordion items={item.content} />
          ) : (
            item.content
          )}
        </RxAccordion.Item>
      ))}
    </S.AccordionWrapper>
  );
};

type AccordionItemProps = {
  title: React.ReactNode | string;
  children: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
};

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  children,
  className,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <S.AccordionTitle
        className={`accordion-title ${className ? className : ""}`}
        onClick={toggleAccordion}
      >
        {title}
        <RxTriangle
          direction={isOpen ? "down" : "right"}
          color={isOpen ? u.colours.marketingGreen : "#E8DACF"}
          size={18}
        />
      </S.AccordionTitle>
      <S.AccordionContent className={className} $isOpen={isOpen}>
        <div>{children}</div>
      </S.AccordionContent>
    </>
  );
};

const S = () => {};

S.AccordionWrapper = styled.div`
  margin: 10px 0;

  & .accordion {
    margin: 0;
  }
`;

S.AccordionTitle = styled.div`
  padding: 25px 10px 25px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;

  &.has-accordion-child {
    font-size: 26px;
  }
`;

S.AccordionContent = styled.div<{ $isOpen: boolean }>`
  max-height: ${(props) => (props.$isOpen ? "1000px" : "0px")};
  overflow: hidden;
  transition: max-height 1s ease-in-out;
  border-bottom: 1px solid #e8d1c3;

  &:not(.has-accordion-child) > div {
    padding: 20px;
  }

  & .accordion div:last-child {
    border-bottom: none;
    margin-bottom: 80px;
  }
`;

RxAccordion.Item = AccordionItem;

export default RxAccordion;
